<template>
  <div class="container">
    <div class="section">
      <div class="box">
        <EditPlugin :id="id" />
      </div>
    </div>
  </div>
</template>

<script>
import EditPlugin from "../components/edit/EditPlugin";

export default {
  components: {
    EditPlugin
  },
  props: ["id"]
};
</script>